import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const MetaTags = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new SEO module
    navigate('/seo', { replace: true });
  }, [navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="400px"
    >
      <CircularProgress />
      <Typography variant="body1" sx={{ ml: 2 }}>
        Redirecting to SEO Management...
      </Typography>
    </Box>
  );
};

export default MetaTags;
